// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3c69d45c","879":"669d36c7"}[chunkId] + ".chunk.js";
};